import styled from '@emotion/styled';

export const MyBillsContainer = styled.div`
    margin-top: 2rem;
`;

export const BreadcrumbsWrapper = styled.div`
    margin-bottom: 3rem;
`;
